import { SVGProps } from 'react';

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4001 12H5.60007V10.4H7.20007V8.00002H6.40007V6.40002H8.00007C8.44167 6.40002 8.80007 6.75842 8.80007 7.20002V10.4H10.4001V12ZM8 3.79999C8.552 3.79999 9 4.24799 9 4.79999C9 5.35199 8.552 5.79999 8 5.79999C7.448 5.79999 7 5.35199 7 4.79999C7 4.24799 7.448 3.79999 8 3.79999ZM8 0C3.5888 0 0 3.5888 0 8C0 12.412 3.5888 16 8 16C12.4112 16 16 12.412 16 8C16 3.5888 12.4112 0 8 0Z"
      fill="currentColor"
    />
  </svg>
);
